import { render, staticRenderFns } from "./TakeawayWeb.vue?vue&type=template&id=0ce722be&scoped=true"
import script from "./TakeawayWeb.vue?vue&type=script&lang=js"
export * from "./TakeawayWeb.vue?vue&type=script&lang=js"
import style0 from "./TakeawayWeb.vue?vue&type=style&index=0&id=0ce722be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce722be",
  null
  
)

export default component.exports